module.exports = __webpack_public_path__ + "fonts/iconfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/iconfont.woff?t=1620798987493
// module id = 992
// module chunks = 0